/**
 * Hide bundle-only selling plans from the Bonde cart drawer.
 *
 * The Appstle group carries two 0%-discount plans ("Monthly ", "Bi-Monthly")
 * that exist only for bundle purchases — the bundle discount must not stack
 * with the 15% subscription discount. Bonde's cart sidebar has no plan-filter
 * setting and renders every plan returned by its sidebar-config endpoint, so
 * this script filters those plans out of that one response before Bonde sees it.
 *
 * Scope: ONLY the POST /apps/conspire-bundle/api/proxy_route/cart/sidebar-config
 * response is touched. The product-subscriptions endpoint feeds the Bonde
 * bundle builder (build-a-box / build-a-set), which needs the 0% plans —
 * do not filter it.
 *
 * Must load synchronously (no defer/async) before {{ content_for_header }}
 * so the fetch patch is in place before bonde.js (defer) runs.
 */
(function () {
  'use strict';

  var HIDDEN_PLAN_IDS = [
    '691982926105', // "Monthly " — 0%, bundle-only
    '691985383705', // "Bi-Monthly" — 0%, bundle-only
  ];

  var SIDEBAR_CONFIG_PATH = '/apps/conspire-bundle/api/proxy_route/cart/sidebar-config';

  function isHiddenPlan(gid) {
    var id = String(gid || '');
    for (var i = 0; i < HIDDEN_PLAN_IDS.length; i++) {
      if (id.indexOf(HIDDEN_PLAN_IDS[i]) !== -1) return true;
    }
    return false;
  }

  function filterSidebarConfig(data) {
    if (!data || !Array.isArray(data.subscription_upsells)) return data;
    data.subscription_upsells.forEach(function (upsell) {
      if (Array.isArray(upsell.all_selling_plans)) {
        upsell.all_selling_plans = upsell.all_selling_plans.filter(function (plan) {
          return !isHiddenPlan(plan.selling_plan_id);
        });
      }
      // If the suggested swap plan is a hidden one, fall back to the first visible plan
      if (isHiddenPlan(upsell.selling_plan_id) && upsell.all_selling_plans && upsell.all_selling_plans.length) {
        var first = upsell.all_selling_plans[0];
        upsell.selling_plan_id = first.selling_plan_id;
        upsell.selling_plan_name = first.selling_plan_name;
        upsell.discount_percentage = first.discount_percentage;
      }
    });
    return data;
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.indexOf(SIDEBAR_CONFIG_PATH) === -1) {
      return originalFetch.apply(this, arguments);
    }
    return originalFetch.apply(this, arguments).then(function (response) {
      if (!response.ok) return response;
      return response
        .clone()
        .json()
        .then(function (data) {
          return new Response(JSON.stringify(filterSidebarConfig(data)), {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers,
          });
        })
        .catch(function () {
          return response;
        });
    });
  };
})();
